import { render, staticRenderFns } from "./ModuleReleasedAt.vue?vue&type=template&id=f5812896"
import script from "./ModuleReleasedAt.vue?vue&type=script&lang=js"
export * from "./ModuleReleasedAt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports